(ns manatee.qa.view.compare-item-edits
  (:require [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.annotation.components :as annotation-components]
            [manatee.components.answer :as answer-components]
            [manatee.domain.task :as task-config]
            [manatee.qa.handlers :as handlers]
            [manatee.qa.subs :as subs]
            [manatee.qa.view.answer :as view-answer]
            [manatee.qa.view.shared :as view-shared]
            [manatee.ui.templates :as templates]
            [re-frame.core :as rf]
            [rothko.accordion.component :refer [accordion]]
            [rothko.layout.component :refer [layout]]
            [rothko.panel.component :refer [panel]]))

(defn comparate-edit
  [item which {:keys [user-id item-id] :as edit} which-other-edit other-edit]
  ^{:key (hash edit)}
  [:div.answer-panel
   [view-answer/annotate-item item edit {:hide-question? true}]
   [:div.button-wrapper
    (let [opts {:on-success-main [::handlers/send-qa-edit-success
                                  [::handlers/load-user-item-edits
                                   user-id
                                   item-id
                                   [::handlers/re-load-comparate-edit-success
                                    {:which which
                                     :which-other-edit which-other-edit
                                     :other-edit-id (:id other-edit)}]]]}]
      [view-answer/submit-edit-button item edit opts])]
   [view-answer/send-feedback item edit]])

(defn question-wrapper
  [{:keys [question] :as item} task-config]
  ^{:key (hash question)}
  (let [scoring-task? (task-config/scoring? task-config)]
    [panel {:appearance #{:primary}}
     (when (answer-components/question-content? question)
       [accordion {:appearance #{:primary}
                   :open #{:question}
                   :items [{:key     :question
                            :title   [:h5 "Question"]
                            :content [answer-components/question-content (answer-components/make-answer-props item
                                                                                                              task-config
                                                                                                              scoring-task?
                                                                                                              {})]}]}])]))

(defn main-panel
  [task-config item edit-a edit-b]
  [:div.qa-view-container
   [annotation-components/alert-container]
   [panel {:appearance #{:simple}}
    [:h4 "Compare Edits"]
    (if (and item edit-a edit-b (not @(rf/subscribe [::subs/qa-loading])))
      [:<>
       [layout {:appearance #{:qa-view-details}}
        [view-shared/edit-details task-config item edit-a "Edit A Details"]
        [view-shared/item-details task-config item {:compact? true}]
        [view-shared/edit-details task-config item edit-b "Edit B Details"]]
       [layout {:appearance #{:qa-view-details}}
        [question-wrapper item task-config]]
       [layout {:appearance #{:qa-compare-view}}
        [comparate-edit item :edit-a edit-a :edit-b edit-b]
        [comparate-edit item :edit-b edit-b :edit-a edit-a]]
       [:div.action-buttons
        [view-shared/go-back-button]]]
      [view-answer/loading-spinner])]
   [annotation-components/display-raw-item-data task-config item]])

(defn container
  []
  (let [{:keys [task-config-id] :as item} @(rf/subscribe [::subs/item])
        task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])
        {:keys [edit-a edit-b]} @(rf/subscribe [::subs/comparate-edits])]
    [main-panel task-config item edit-a edit-b]))

(def page
  {:template templates/single-column
   :main container})
